import { render } from "./JuryInstructionsDetailsModal.vue?vue&type=template&id=b89a5f46"
import script from "./JuryInstructionsDetailsModal.vue?vue&type=script&lang=js"
export * from "./JuryInstructionsDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__